<template>
  <div class="studio">
    <div class="bg">
      <img src="@/assets/studio-page/bg.png">
    </div>
    <headerr class="header" />
    <div class="col">
        <router-view />
    </div>
  </div>
</template>

<script>
import Headerr from "./header"
export default {
  components: {
    Headerr,
  },
}
</script>

<style scoped lang="scss">
.studio {
  color: #d5d5d5;
  height: 100%;
  width: 100%;
  font-family: 'Franklin Gothic', 'Arial Narrow', Arial, sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}


.bg {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: -1000;
  overflow: hidden;

  img {
    height: 116%;
    width: auto;
    position: absolute;
    left: -816px;
    top: -51px;
  }
}

.col {
  width: 55%;
  height: 100%;
  background-color: rgba(black, 0.90);
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 3vh;
}
@media only screen and (max-width: 1600px) {
  .col {
    width: 70%;
  }
}
@media only screen and (max-width: 962px) {
  .col {
    width: 90%;
    padding-top: 1vh;
  }
}

@media only screen and (max-width: 1600px) {
  .bg img {
    left: -1000px
  }
}
@media only screen and (max-width: 1000px) {
  .bg img {
    height: 106%;
    left: -1100px
  }
}
@media only screen and (max-width: 900px) {
  .bg img {
    height: 100%;
    left: 0px;
  }
}
</style>